import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, browserHistory } from 'react-router';
import './styles/global.scss';
import './index.css';
import routes from "./routes";
import reducer from "./reducer";
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from 'redux-saga'
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import {Map} from "immutable";
import authSaga from "./sagas/authSaga";
import inventoryApiSaga from "./sagas/inventoryApiSaga";
import stockTransferApiSaga from "./sagas/stockTransferApiSaga";
import clientDispatchApiSaga from "./sagas/clientDispatchApiSaga";
import partnerApiSaga from "./sagas/partnerApiSaga";
import purchaseOrderApiSaga from "./sagas/purchaseOrderApiSaga";
import serialNumberSaga from "./sagas/serialNumberSaga";
import consignmentApiSaga from "./sagas/consignmentApiSaga";
import shippingApiSaga from "./sagas/shippingApiSaga";
import salesApiSaga from "./sagas/salesApiSaga";
import accountApiSaga from "./sagas/accountApiSaga";
import subscriptionApiSaga from "./sagas/subscriptionApiSaga";
import viewSaga from "./sagas/viewSaga";
import infrastructureSaga from "./sagas/infrastructureSaga";
import onboardingApiSaga from "./sagas/onboardingApiSaga";
import checkoutApiSaga from "./sagas/checkoutApiSaga";
import notesSaga from "./notes/notesSaga";
import {ApolloProvider} from "react-apollo";
import client from "./client";
// import registerServiceWorker from './registerServiceWorker';

const sagaMiddleware = createSagaMiddleware();
var middleware = [sagaMiddleware];
const store = createStore(reducer, Map(), composeWithDevTools(applyMiddleware(...middleware)));
sagaMiddleware.run(infrastructureSaga);
sagaMiddleware.run(viewSaga);
sagaMiddleware.run(authSaga);
sagaMiddleware.run(inventoryApiSaga);
sagaMiddleware.run(stockTransferApiSaga);
sagaMiddleware.run(clientDispatchApiSaga);
sagaMiddleware.run(partnerApiSaga);
sagaMiddleware.run(purchaseOrderApiSaga);
sagaMiddleware.run(serialNumberSaga);
sagaMiddleware.run(consignmentApiSaga);
sagaMiddleware.run(shippingApiSaga);
sagaMiddleware.run(salesApiSaga);
sagaMiddleware.run(accountApiSaga);
sagaMiddleware.run(subscriptionApiSaga);
sagaMiddleware.run(onboardingApiSaga);
sagaMiddleware.run(checkoutApiSaga);
sagaMiddleware.run(notesSaga);


ReactDOM.render((
  <Provider store={store}>
    <ApolloProvider client={client}>
      <Router history={browserHistory}>{routes}</Router>
    </ApolloProvider>
  </Provider>
), document.getElementById('root'));
// registerServiceWorker();
